import React , {useState , useEffect} from "react";
import BarChart from "../../components/BarChart";
import PieChart from "../../components/PieChart";
import HorizontalBar from "../../components/HorizontalBar";
import HorizontalThreeBar from "../../components/HorizontalThreeBar";
import GuageChart from "../../components/GuageChart";
import GuageChartOld from "../../components/GaugeChartOld";
import VerticalProgressBar from "../../components/VerticalProgressBar";
import { formatNumber, formatNumberWithoutFraction } from "../../utility";
import ActiveMember from "../../assets/active-member.svg";
import InActiveMember from "../../assets/inactive-member.svg";
import OnLeave from "../../assets/on-leave.svg";
import MetricBar from "../../components/MetricBar";
import { useTranslation } from "react-i18next";
import Loader from "../../components/Loader";

interface ChannelProps {
  dashobardData: any;
  liveTodayVisitMetrics?: any;
  setStatus:(status: string) => void,
  status:string,
  dashboardDataa:any,
  dashboardDataaLoading: boolean,
  startDate: string,
  endDate: string,
  timeFrame: string
}

const SkeletonLoader = () => (
  <div className="flex justify-center items-center w-full">
    <div className="relative overflow-hidden rounded-lg h-12 w-full max-w-[220px] bg-gray-200 my-2">
      <div className="absolute inset-0 animate-skeleton-shimmer bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200" />
    </div>
  </div>
);

const Channel: React.FC<ChannelProps> = ({ dashobardData, liveTodayVisitMetrics, setStatus , status,dashboardDataa, dashboardDataaLoading, startDate, endDate, timeFrame}) => {
  
  const dataForBarChart = [
    {
      visits: "A",
      value: dashobardData?.visit_metrics?.successful_visits_count
        ? dashobardData?.visit_metrics?.successful_visits_count 
        : 0,
    },
    {
      visits: "B",
      value: dashobardData?.visit_metrics?.collection_visits_count
        ? dashobardData?.visit_metrics?.collection_visits_count 
        : 0,
    },
    {
      visits: "C",
      value: dashobardData?.visit_metrics?.failed_visits_count
        ? dashobardData?.visit_metrics?.failed_visits_count
        : 0,
    },
    {
      visits: "D",
      value: dashobardData?.visit_metrics?.total_visits_count
        ? dashobardData?.visit_metrics?.total_visits_count 
        : 0,
    },
  ];

  const pieChartDataCallPlan = [
    {
      name: "Planned Visits",
      value: dashobardData?.visit_metrics?.planned_visits_count
        ? formatNumberWithoutFraction(Number(dashobardData?.visit_metrics?.total_visits_count) -
        Number(dashobardData?.visit_metrics?.unplanned_visits_count))
        : 0,
      color: "#00C48C",
      id: "Planned Visits",
    },
    {
      name: "Unplanned Visits",
      value: dashobardData?.visit_metrics?.unplanned_visits_count
        ? formatNumberWithoutFraction(dashobardData?.visit_metrics?.unplanned_visits_count) 
        : 0,
      color: "#FFAA2A",
      id: "Unplanned Visits",
    },
    {
      name: "Pending Planned Visits",
      value: dashobardData?.visit_metrics?.pending_visits_count
        ? formatNumberWithoutFraction(dashobardData?.visit_metrics?.pending_visits_count)
        : 0,
      color: "#FF4D68",
      id: "Pending Planned Visits",
    },
  ];
  const { t } = useTranslation();
  
  const handleStatusClick = (status:any) => {
    setStatus(status);
  };
  const [selectedStatus, setSelectedStatus] = useState(null);

  const toggleStatus = (status: any) => {
    if (selectedStatus === status) {
      setSelectedStatus(null);
      handleStatusClick("");
    } else {
      setSelectedStatus(status);
      handleStatusClick(status);
    }
  };

  // Function to determine if updatedtargetCartons should be shown
  const shouldShowUpdatedTargetCartons = () => {
    // Case 1: Today filter is selected
    if (timeFrame === "Today") {
      return true;
    }
    
    // Case 2: Yesterday filter is selected
    if (timeFrame === "Yesterday") {
      return true;
    }
    
    // Case 3: Single day range (startDate equals endDate)
    if (startDate && endDate && startDate === endDate) {
      return true;
    }
    
    // All other cases: hide the field
    return false;
  };

  // Single day = Today, Yesterday, or same start/end date. Otherwise = Date Range or MTD.
  const isSingleDayFilter = timeFrame === "Today" || timeFrame === "Yesterday" || (startDate && endDate && startDate === endDate);
  // For Sales Achievement (Live) card: always use today's data when single day filter (from extra API call with date=today).
  const liveCardMetrics = isSingleDayFilter ? (liveTodayVisitMetrics ?? dashobardData?.visit_metrics) : null;

  const getFormattedValue = (data: any) => {
    if (Number(data) === 0) {
      return 0;
    }
    const value = Number(data / 4);
    return value > 0.25 ? value : 0.25;
  };

  const dashboardMetrics = [
    {
      number: "01",
      text: "DashboardAnalytics.shopPermanentClosed",
      count: Number(dashobardData?.visit_metrics?.shop_permanently_closed_count || 0) ,
      color: "#408BFC",
      bgcolor: "#F0F9FF",
    },
    {
      number: "02",
      text: "DashboardAnalytics.shopTemporaryClosed",
      count: Number(dashobardData?.visit_metrics?.shop_temporarily_closed_count || 0),
      color: "#00C48C",
      bgcolor: "#E8FAF5",
    },
    {
      number: "03",
      text: "DashboardAnalytics.collectionIssue",
      count: Number(dashobardData?.visit_metrics?.collection_issue_count || 0),
      color: "#BE52F2",
      bgcolor: "#F1D4FF80",
    },
    {
      number: "04",
      text: "DashboardAnalytics.highStock",
      count: Number(dashobardData?.visit_metrics?.high_stock_count || 0),
      color: "#FFAA2A",
      bgcolor: "#FCF8EB",
    },
    {
      number: "05",
      text: "DashboardAnalytics.other",
      count: Number(dashobardData?.visit_metrics?.other_count || 0),
      color: "#FF4D68",
      bgcolor: "#FCEFF0",
    },
  ];

  // Find the highest value among all counts
  const highestValue = Math.max(
    ...dashboardMetrics.map((metric) => metric.count)
  );

  useEffect(() => {
  if(!status){
    toggleStatus('')
  }
  }, [status])
  
  return (
    <>
      <div className="md:w-full  h-auto lg:h-[calc(100vh-140px)]  lg:overflow-y-scroll flex flex-col gap-2 pr-2 scrollbar scrollbar-thin ">
        <div className="flex justify-between gap-2  w-full flex-col md:flex-row bg-[#F5F5F5] p-2 rounded-md">
          <div className="bg-white border-2 border-purple p-[20px] flex flex-col w-full rounded">
            <div className="text-left">
              <h2 className="text-13 font-bold ">
                {t("DashboardAnalytics.teamCount")}
              </h2>
            </div>
            <div className="flex justify-center gap-3 items-center pt-1">
              <div className="flex flex-col w-full rounded ">
                <div className="flex gap-2 items-center justify-between">
                  <p className="font-normal text-13">
                    {t("DashboardAnalytics.preseller")}
                  </p>
                  <p className="text-xl font-bold">
                    {formatNumberWithoutFraction(
                      dashobardData?.team_metrics?.total_preseller_count || 0
                    )}
                  </p>
                </div>
                <div className="flex gap-2 items-center justify-between">
                  <p className="font-normal text-13">
                    {t("DashboardAnalytics.salesman")}
                  </p>
                  <p className="text-xl font-bold">
                    {formatNumberWithoutFraction(
                      dashobardData?.team_metrics?.total_salesman_count || 0
                    )}
                  </p>
                </div>

               
              </div>
              <div className="flex flex-col items-center min-w-[80px] pl-3 border-l-2">
                {/* <div className="h-12 w-[6px] rounded-lg bg-purple mr-2"></div> */}
                <p className="text-13  font-normal	">
                  {t("DashboardAnalytics.total")}
                </p>
                <p className="text-purple text-[39px] font-bold">
                  {formatNumberWithoutFraction(
                    dashobardData?.team_metrics?.total_team_count || 0
                  )}
                </p>
              </div>
            </div>
          </div>

          <div
        className={`bg-green-50 p-[20px] w-full rounded border-2 cursor-pointer ${
          selectedStatus === "A" ? "border-4 border-green-400" : "border-cugreen"
        }`}
        onClick={() => toggleStatus("A")}
      >
        <div className="text-left flex flex-col justify-between">
          <h2 className="text-green-600 text-base font-semibold">
            {t("DashboardAnalytics.activeMembers")}
          </h2>
          <div className="flex justify-center gap-3 items-center pt-1">
            <div className="flex flex-col w-full rounded">
              <div className="flex gap-2 items-center justify-between">
                <p className="font-normal text-13">
                  {t("DashboardAnalytics.dd")}
                </p>
                <p className="text-xl font-bold">
                  {formatNumberWithoutFraction(
                    dashobardData?.team_metrics?.channels?.find((channel: any) => channel.channel_id === "20")?.total_active_count || 0
                  )}
                </p>
              </div>
              {/*
              <div className="flex gap-2 items-center justify-between">
                <p className="font-normal text-13">
                  {t("DashboardAnalytics.KEY_RETAIL")}
                </p>
                <p className="text-xl font-bold">
                  {formatNumberWithoutFraction(
                    dashobardData?.team_metrics?.channels?.find((channel: any) => channel.channel_id === "60")?.total_active_count || 0
                  )}
                </p>
              </div>
              <div className="flex gap-2 items-center justify-between">
                <p className="font-normal text-13">
                  {t("DashboardAnalytics.KEY_ACCOUNT")}
                </p>
                <p className="text-xl font-bold">
                  {formatNumberWithoutFraction(
                    dashobardData?.team_metrics?.channels?.find((channel: any) => channel.channel_id === "10")?.total_active_count || 0
                  )}
                </p>
              </div>
              <div className="flex gap-2 items-center justify-between">
                <p className="font-normal text-13">
                  {t("DashboardAnalytics.WHOLESALE")}
                </p>
                <p className="text-xl font-bold">
                  {formatNumberWithoutFraction(
                    dashobardData?.team_metrics?.channels?.find((channel: any) => channel.channel_id === "50")?.total_active_count || 0
                  )}
                </p>
              </div>
              */}
            </div>
            <div className="flex flex-col items-center min-w-[80px] pl-3 border-l-2">
              <p className="text-13 font-normal">
                {t("DashboardAnalytics.total")}
              </p>
              <p className="text-green-600 text-[39px] font-bold">
                {formatNumberWithoutFraction(
                  dashobardData?.team_metrics?.total_active_count || 0
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`bg-red-50 p-[20px] w-full rounded border-2 border-[#FF4D68] cursor-pointer ${
          selectedStatus === "I" ? "border-4 border-red-400" : "border-[#FF4D68]"
        }`}
        onClick={() => toggleStatus("I")}
      >
        <div className="text-left flex justify-between flex-col">
          <h2 className="text-red-600 text-base font-semibold">
            {t("DashboardAnalytics.inactiveMembers")}
          </h2>
          <div className="flex justify-center gap-3 items-center pt-1">
            <div className="flex flex-col w-full rounded">
              <div className="flex gap-2 items-center justify-between">
                <p className="font-normal text-13">
                  {t("DashboardAnalytics.dd")}
                </p>
                <p className="text-xl font-bold">
                  {formatNumberWithoutFraction(
                    dashobardData?.team_metrics?.channels?.find((channel: any) => channel.channel_id === "20")?.total_inactive_count || 0
                  )}
                </p>
              </div>
              {/*
              <div className="flex gap-2 items-center justify-between">
                <p className="font-normal text-13">
                  {t("DashboardAnalytics.KEY_RETAIL")}
                </p>
                <p className="text-xl font-bold">
                  {formatNumberWithoutFraction(
                    dashobardData?.team_metrics?.channels?.find((channel: any) => channel.channel_id === "60")?.total_inactive_count || 0
                  )}
                </p>
              </div>
              <div className="flex gap-2 items-center justify-between">
                <p className="font-normal text-13">
                  {t("DashboardAnalytics.KEY_ACCOUNT")}
                </p>
                <p className="text-xl font-bold">
                  {formatNumberWithoutFraction(
                    dashobardData?.team_metrics?.channels?.find((channel: any) => channel.channel_id === "10")?.total_inactive_count || 0
                  )}
                </p>
              </div>
              <div className="flex gap-2 items-center justify-between">
                <p className="font-normal text-13">
                  {t("DashboardAnalytics.WHOLESALE")}
                </p>
                <p className="text-xl font-bold">
                  {formatNumberWithoutFraction(
                    dashobardData?.team_metrics?.channels?.find((channel: any) => channel.channel_id === "50")?.total_inactive_count || 0
                  )}
                </p>
              </div>
              */}
            </div>
            <div className="flex flex-col items-center min-w-[80px] pl-3 border-l-2">
              <p className="text-13 font-normal">
                {t("DashboardAnalytics.total")}
              </p>
              <p className="text-[39px] text-[#FF4D68] font-bold">
                {formatNumberWithoutFraction(
                  dashobardData?.team_metrics?.total_inactive_count || 0
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

          {/* <div className="bg-blue-50 p-[20px] w-full rounded border-2 border-[#408BFC]">
            <div className="text-left flex justify-between flex-col">
              <h2 className="text-blue-600 text-base font-semibold">
                {t("DashboardAnalytics.employeesOnLeave")}
              </h2>
            </div>
            <div className="flex justify-between pt-1 items-center">
              <p className=" text-blue-600 text-[39px] font-bold">
                {formatNumberWithoutFraction(
                  dashobardData?.team_metrics?.total_on_leave_count || 0
                )}
              </p>
              <img src={OnLeave} alt="" />
            </div>
          </div> */}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 bg-[#F5F5F5] p-2 rounded">
          <div className="bg-white border-2 p-4 flex flex-col rounded">
            <h2 className="text-[13px] font-semibold">
              {t("DashboardAnalytics.callPlanAdherence")}
            </h2>
            <div className="flex pt-2">
              <div className="flex flex-col w-[30%] gap-2">
                <div className="flex flex-col">
                  <p className="font-semibold">
                    <span className="text-[31px]">
                      {formatNumberWithoutFraction(
                        dashobardData?.visit_metrics?.total_visits_count || 0
                      )}
                    </span>
                    <span className="text-[20px]">
                      /
                      {formatNumberWithoutFraction(
                        dashobardData?.visit_metrics?.planned_visits_count || 0
                      )}
                    </span>
                  </p>
                  <p className="text-[13px] font-semibold">
                    {t("DashboardAnalytics.noOfVisits")}
                  </p>
                </div>
                <div className="flex flex-col">
                  <p className="text-cugreen text-[25px] font-bold">
                    {formatNumberWithoutFraction( Number(dashobardData?.visit_metrics?.total_visits_count) -
                      Number(
                        dashobardData?.visit_metrics?.unplanned_visits_count
                      ))}
                  </p>
                  <p className="text-[13px] font-semibold">
                    {t("DashboardAnalytics.plannedVisits")}
                  </p>
                </div>
                <div className="flex flex-col">
                  <p className="text-[#FFAA2A] text-[25px] font-bold">
                    {formatNumberWithoutFraction(
                      dashobardData?.visit_metrics?.unplanned_visits_count || 0
                    )}
                  </p>
                  <p className="text-[13px] font-semibold">
                    {t("DashboardAnalytics.unplannedVisits")}
                  </p>
                </div>
                <div className="flex flex-col">
                  <p className="text-[#FF4D68] text-[25px] font-bold">
                    {formatNumberWithoutFraction(
                      dashobardData?.visit_metrics?.pending_visits_count || 0
                    )}
                  </p>
                  <p className="text-[13px] font-semibold">
                    {t("DashboardAnalytics.pendingPlannedVisits")}
                  </p>
                </div>
              </div>
              <div className="h-[300px] w-[70%] flex justify-center">
                <PieChart data={pieChartDataCallPlan} />
              </div>
            </div>
          </div>

          <div className="bg-white p-4 border-2 flex flex-col rounded">
            <h2 className="text-[13px] font-bold mb-4">
              {t("DashboardAnalytics.visitsRatio")}
            </h2>
            <div className="h-[200px] w-full mb-4">
              <BarChart
                data={dataForBarChart}
                barColors={["#00C48C", "#FFAA2A", "#FF4D68", "#408BFC"]}
              />
            </div>
            <div className="flex flex-col justify-center gap-2">
              <div className="flex justify-between">
                <div className="flex gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#00C48C" }}
                  ></div>
                  <span className=" text-[13px]">
                    {t("DashboardAnalytics.successfulVisits")}
                  </span>
                </div>
                <span className="ml-2 text-base">
                  {formatNumberWithoutFraction(
                    dashobardData?.visit_metrics?.successful_visits_count || 0
                  )}
                </span>
              </div>
              <div className="flex justify-between">
                <div className="flex gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#FFAA2A" }}
                  ></div>
                  <span className="text-[13px]">
                    {t("DashboardAnalytics.collectionVisits")}
                  </span>
                </div>
                <span className="ml-2 text-base">
                  {formatNumberWithoutFraction(
                    dashobardData?.visit_metrics?.collection_visits_count || 0
                  )}
                </span>
              </div>
              <div className="flex justify-between">
                <div className="flex gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#FF4D68" }}
                  ></div>
                  <span className=" text-[13px]">
                    {t("DashboardAnalytics.failedVisits")}
                  </span>
                </div>
                <span className="ml-2 text-base">
                  {formatNumberWithoutFraction(
                    dashobardData?.visit_metrics?.failed_visits_count || 0
                  )}
                </span>
              </div>
              <div className="flex justify-between">
                <div className="flex gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#408BFC" }}
                  ></div>
                  <span className="text-[13px]">
                    {t("DashboardAnalytics.totalVisits")}
                  </span>
                </div>
                <span className="ml-2 text-base">
                  {formatNumberWithoutFraction(
                    dashobardData?.visit_metrics?.total_visits_count || 0
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#F5F5F5] p-2 rounded-md flex flex-col gap-4">
          <div className="bg-white p-4 border-2 flex flex-col gap-2 rounded">
            <h2 className="text-13 font-bold">
              {t("DashboardAnalytics.failedVisitsReasons")}
            </h2>
            {dashboardMetrics.map((metric) => (
              <MetricBar
                key={metric.number}
                number={metric.number}
                text={t(metric.text)}
                count={metric.count}
                color={metric.color}
                bgcolor={metric.bgcolor}
                highestValue={highestValue} // Pass highest value for comparison
              />
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {/* Sales Achievement - Cartons vs Planned Target (original layout, but with actual target) */}
            <div className="bg-white p-4 border-2 flex flex-col">
              <h2 className="text-13 font-bold mb-4">
                {t("DashboardAnalytics.salesAchievement")} (Planned Target MTD)
              </h2>
              <div className="flex justify-between">
                <div className="flex flex-col justify-center">
                  <div className="flex flex-col items-start">
                    <div className="text-[25px] font-bold">
                      {formatNumberWithoutFraction(
                        dashobardData?.visit_metrics?.total_cartons_sold_count || 0
                      )}
                    </div>
                    <div className="text-13 font-semibold">
                      {t("DashboardAnalytics.cartons")}
                    </div>
                  </div>
                  <div className="flex flex-col items-start mt-4">
                    <div className="text-[25px] font-bold text-red-500">
                      {formatNumberWithoutFraction(
                        dashobardData?.visit_metrics?.total_cartons_actual_target_count || 0
                      )}
                    </div>
                    <div className="text-13 font-semibold">
                      Planned target cartons
                    </div>
                  </div>
                </div>
                <div className="flex justify-center w-[75%]">
                  <div className="w-full flex flex-col items-center">
                    <GuageChart
                      served={
                        dashobardData?.visit_metrics?.total_cartons_sold_count || 0
                      }
                      pending={Math.max(
                        0,
                          (dashobardData?.visit_metrics?.total_cartons_actual_target_count || 0) -
                          (dashobardData?.visit_metrics?.total_cartons_sold_count || 0)
                      )}
                      target={
                          dashobardData?.visit_metrics?.total_cartons_actual_target_count || 0
                      }
                      value={
                          (dashobardData?.visit_metrics?.total_cartons_actual_target_count || 0) > 0
                          ? (dashobardData?.visit_metrics?.total_cartons_sold_count || 0) /
                            (dashobardData?.visit_metrics?.total_cartons_actual_target_count || 0)
                          : 0
                      }
                      labelValue={
                        dashobardData?.visit_metrics?.total_cartons_sold_count || 0
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-center mt-4">
                <div className="flex items-center mx-4 gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#00C48C" }}
                  ></div>
                  <span className=" text-xs">
                    {t("DashboardAnalytics.actualSales")}
                  </span>
                </div>
                <div className="flex items-center mx-4 gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#FF4D68" }}
                  ></div>
                  <span className=" text-xs">
                    {t("DashboardAnalytics.pendingSales")}
                  </span>
                </div>
              </div>
            </div>

            {/* Sales Achievement - Cartons vs Today's Target (updated target, middle card) */}
            <div className={`bg-white p-4 border-2 flex flex-col ${!isSingleDayFilter ? "opacity-25 bg-gray-100 pointer-events-none" : ""}`}>
              <h2 className="text-13 font-bold mb-4">
                {t("DashboardAnalytics.salesAchievement")} (Today's Target)
              </h2>
              <div className="flex justify-between">
                <div className="flex flex-col justify-center">
                  <div className="flex flex-col items-start">
                    <div className="text-[25px] font-bold">
                      {formatNumberWithoutFraction(
                        isSingleDayFilter ? (dashobardData?.visit_metrics?.total_cartons_sold_count || 0) : 0
                      )}
                    </div>
                    <div className="text-13 font-semibold">
                      {t("DashboardAnalytics.cartons")}
                    </div>
                  </div>
                  <div className="flex flex-col items-start mt-4">
                    <div className="text-[25px] font-bold text-red-500">
                      {formatNumberWithoutFraction(
                        isSingleDayFilter ? (dashobardData?.visit_metrics?.total_cartons_target_count || 0) : 0
                      )}
                    </div>
                    <div className="text-13 font-semibold">
                      Today's target cartons
                    </div>
                  </div>
                </div>
                <div className="flex justify-center w-[75%]">
                  <div className="w-full flex flex-col items-center">
                    <GuageChart
                      served={isSingleDayFilter ? (dashobardData?.visit_metrics?.total_cartons_sold_count || 0) : 0}
                      pending={isSingleDayFilter ? Math.max(0, (dashobardData?.visit_metrics?.total_cartons_target_count || 0) - (dashobardData?.visit_metrics?.total_cartons_sold_count || 0)) : 0}
                      target={isSingleDayFilter ? (dashobardData?.visit_metrics?.total_cartons_target_count || 0) : 0}
                      value={isSingleDayFilter && (dashobardData?.visit_metrics?.total_cartons_target_count || 0) > 0 ? (dashobardData?.visit_metrics?.total_cartons_sold_count || 0) / (dashobardData?.visit_metrics?.total_cartons_target_count || 0) : 0}
                      labelValue={isSingleDayFilter ? (dashobardData?.visit_metrics?.total_cartons_sold_count || 0) : 0}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-center mt-4">
                <div className="flex items-center mx-4 gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#00C48C" }}
                  ></div>
                  <span className=" text-xs">
                    {t("DashboardAnalytics.actualSales")}
                  </span>
                </div>
                <div className="flex items-center mx-4 gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#FF4D68" }}
                  ></div>
                  <span className=" text-xs">
                    {t("DashboardAnalytics.pendingSales")}
                  </span>
                </div>
              </div>
            </div>

            {/* Sales Achievement - Cartons vs Live Updated Target Cartons (always today's data when single day) */}
            <div className={`bg-white p-4 border-2 flex flex-col ${!isSingleDayFilter ? "opacity-25 bg-gray-100 pointer-events-none" : ""}`}>
              <h2 className="text-13 font-bold mb-4">
                {t("DashboardAnalytics.salesAchievement")} (Live)
              </h2>
              <div className="flex justify-between">
                <div className="flex flex-col justify-center">
                  <div className="flex flex-col items-start">
                    <div className="text-[25px] font-bold">
                      {formatNumberWithoutFraction(
                        isSingleDayFilter ? (liveCardMetrics?.total_cartons_sold_count || 0) : 0
                      )}
                    </div>
                    <div className="text-13 font-semibold">
                      {t("DashboardAnalytics.cartons")}
                    </div>
                  </div>
                  <div className="flex flex-col items-start mt-4">
                    <div className="text-[25px] font-bold text-purple">
                      {formatNumberWithoutFraction(
                        isSingleDayFilter ? (liveCardMetrics?.live_updated_cartons_target_count || 0) : 0
                      )}
                    </div>
                    <div className="text-13 font-semibold">
                      Live updated target cartons
                    </div>
                  </div>
                </div>
                <div className="flex justify-center w-[75%]">
                  <div className="w-full flex flex-col items-center">
                    <GuageChart
                      served={isSingleDayFilter ? (liveCardMetrics?.total_cartons_sold_count || 0) : 0}
                      pending={isSingleDayFilter ? Math.max(0, (liveCardMetrics?.live_updated_cartons_target_count || 0) - (liveCardMetrics?.total_cartons_sold_count || 0)) : 0}
                      target={isSingleDayFilter ? (liveCardMetrics?.live_updated_cartons_target_count || 0) : 0}
                      value={isSingleDayFilter && (liveCardMetrics?.live_updated_cartons_target_count || 0) > 0 ? (liveCardMetrics?.total_cartons_sold_count || 0) / (liveCardMetrics?.live_updated_cartons_target_count || 0) : 0}
                      labelValue={isSingleDayFilter ? (liveCardMetrics?.total_cartons_sold_count || 0) : 0}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-center mt-4">
                <div className="flex items-center mx-4 gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#00C48C" }}
                  ></div>
                  <span className=" text-xs">
                    {t("DashboardAnalytics.actualSales")}
                  </span>
                </div>
                <div className="flex items-center mx-4 gap-2">
                  <div
                    className="h-4 w-4 rounded-full"
                    style={{ backgroundColor: "#FF4D68" }}
                  ></div>
                  <span className=" text-xs">
                    {t("DashboardAnalytics.pendingSales")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex w-full flex-col md:flex-col lg:flex-row gap-2">
          <div className="flex gap-2 flex-col md:w-full lg:w-[70%]">
            <div className="flex gap-4 bg-[#F5F5F5] p-2 rounded w-full flex-col md:flex-row">
              <div className="flex flex-col gap-4 w-full md:w-1/2">
                {/* COD Percentage */}
                {/* Number of Unique Accounts Served */}
                <div className="bg-white p-3 border-2 flex flex-col rounded">
                  <h2 className="text-13 font-bold mb-4">
                    {t("DashboardAnalytics.numberOfUniqueAccountsServed")}
                  </h2>
                  {dashboardDataaLoading ? (
                    <SkeletonLoader />
                  ) : (
                    <div className="flex justify-between">
                      <div className="flex flex-col justify-center">
                        <div className="flex flex-col items-start">
                          <div className="text-[24px] font-bold">
                            {formatNumberWithoutFraction(
                              dashboardDataa?.unique_accounts_served_count
                            )}
                            <span className="text-[16px] font-semibold">
                              /{" "}
                              {formatNumberWithoutFraction(
                                dashboardDataa?.unique_accounts_target_count || 0
                              )}
                            </span>
                          </div>
                          <div className="text-13 font-semibold">
                            {t("DashboardAnalytics.accountsServed")}
                          </div>
                        </div>
                        <div className="flex flex-col items-start mt-2">
                          <div className="text-[20px] font-bold text-red-500">
                            {formatNumberWithoutFraction(
                              dashboardDataa?.unique_accounts_pending_count || 0
                            )}
                          </div>
                          <div className="text-13 font-semibold">
                            {t("DashboardAnalytics.pendingAccounts")}
                          </div>
                        </div>
                      </div>
                      <div className="flex justify-center w-[75%]">
                        <div className=" w-full flex flex-col items-center">
                          <GuageChart
                            served={
                              dashboardDataa?.unique_accounts_served_count
                            }
                            pending={
                              dashboardDataa?.unique_accounts_pending_count || 0
                            }
                            target={
                              dashboardDataa?.unique_accounts_target_count || 0
                            }
                            value={
                              Number(
                                dashboardDataa?.unique_accounts_served_count
                              ) /
                              Number(
                                dashboardDataa?.unique_accounts_target_count ||
                                  0
                              )
                            }
                            labelValue={
                              dashboardDataa?.unique_accounts_served_count
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  
                  <div className="flex justify-center mt-4">
                    <div className="flex items-center mx-4 gap-2">
                      <div
                        className="h-4 w-4 rounded-full"
                        style={{ backgroundColor: "#00C48C" }}
                      ></div>
                      <span className=" text-xs">
                        {t("DashboardAnalytics.accountsServed")}
                      </span>
                    </div>
                    <div className="flex items-center mx-4 gap-2">
                      <div
                        className="h-4 w-4 rounded-full"
                        style={{ backgroundColor: "#FF4D68" }}
                      ></div>
                      <span className=" text-xs">
                        {t("DashboardAnalytics.pendingAccounts")}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-3 border-2 flex flex-col rounded">
                  <h2 className="text-13 font-bold mb-2">
                    {t("DashboardAnalytics.codPercentage")}
                  </h2>
                  <div className="flex flex-row justify-between">
                    <div className="w-[95%] flex flex-col items-center">
                      <GuageChart
                        value={
                          Number(dashobardData?.visit_metrics?.cod_percentage) /
                          100
                        }
                        labelValue={
                          Math.round(
                            dashobardData?.visit_metrics?.cod_percentage
                          ) || 0
                        }
                        target={100}
                        labelBottomOffset="-5px"
                      />
                    </div>
                  </div>
                </div>

                {/* Average SKU / Invoice */}
                <div className="bg-white p-3 border-2 flex flex-col rounded">
                  <h2 className="text-13 font-bold mb-2">
                    {t("DashboardAnalytics.averageSkuInvoice")}
                  </h2>
                  <div className="flex flex-row justify-between">
                    <div className="w-[95%] flex flex-col items-center">
                      <GuageChartOld
                        value={getFormattedValue(
                          Number(
                            dashobardData?.visit_metrics?.average_sku_per_invoice
                          )
                        )}
                        target={4}
                        labelValue={
                          getFormattedValue(
                            Number(
                              dashobardData?.visit_metrics
                                ?.average_sku_per_invoice
                            )
                          ) * 4
                        }
                      />
                    </div>
                  </div>
                </div>

                

                {/* Purchased SKUs per Customer */}
                <div className="bg-white p-3 border-2 flex flex-col rounded">
                  <h2 className="text-13 font-bold mb-2">
                    Purchased SKUs / Customer
                  </h2>
                  <div className="flex flex-row justify-between">
                    <div className="w-[95%] flex flex-col items-center">
                      <GuageChartOld
                        value={getFormattedValue(
                          Number(
                            dashobardData?.visit_metrics?.purchased_skus_per_customer
                          )
                        )}
                        target={4}
                        labelValue={
                          getFormattedValue(
                            Number(
                              dashobardData?.visit_metrics
                                ?.purchased_skus_per_customer
                            )
                          ) * 4
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Average Product / Invoice */}
                <div className="bg-white p-3 border-2 flex flex-col rounded">
                  <h2 className="text-13 font-bold mb-2">
                    {t("DashboardAnalytics.averageProInvoice")}
                  </h2>
                  <div className="flex flex-row justify-between">
                    <div className="w-[95%] flex flex-col items-center">
                      <GuageChartOld
                        value={getFormattedValue(
                          Number(
                            dashobardData?.visit_metrics
                              ?.average_unique_products_per_invoice
                          )
                        )}
                        target={4}
                        labelValue={
                          getFormattedValue(
                            Number(
                              dashobardData?.visit_metrics
                                ?.average_unique_products_per_invoice
                            )
                          ) * 4
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col w-full md:w-1/2 gap-4 flex-1">
                <div className="border border-gray-300 rounded bg-white w-full min-h-[250px] p-4 flex-1">
                  <h2 className="text-13 font-bold">
                    {t("DashboardAnalytics.bundleOrders")}
                  </h2>
                  <div className="flex justify-between items-center mb-2">
                    <div className="pl-0 p-4 text-13">
                      <p>{t("DashboardAnalytics.totalOrders")}</p>
                      <p className="font-bold text-3xl">
                        {formatNumberWithoutFraction(
                          dashobardData?.visit_metrics
                            ?.total_bundle_orders_count || 0
                        )}
                      </p>
                    </div>
                    <div className="border-2 w-[2px] h-12"></div>
                    <div className="border-gray-300 p-4 text-13">
                      <p>{t("DashboardAnalytics.cartonQuantity")}</p>
                      <p className="font-bold text-3xl">
                        {formatNumberWithoutFraction(
                          dashobardData?.visit_metrics?.bundle_cartons_qty || 0
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="border-t border-gray-300 rounded p-4 pl-0">
                    <p className="text-13 font-medium">
                      {t("DashboardAnalytics.orderValue")}
                    </p>
                    <p className="text-3xl font-bold text-purple">
                      {formatNumber(
                        dashobardData?.visit_metrics?.total_bundle_order_value ||
                          0
                      )}{" "}
                      {t("DashboardAnalytics.SAR")}
                    </p>
                  </div>
                </div>
                <div className="border-2 w-full p-2 rounded bg-white">
                  <div className="px-3 p-2 font-bold text-13">
                    {t("DashboardAnalytics.totalCartonSales")}
                  </div>
                  <VerticalProgressBar
                    firstAmount={
                      dashobardData?.visit_metrics
                        ?.preseller_cartons_sold_count || 0
                    }
                    secondAmount={
                      dashobardData?.visit_metrics
                        ?.salesman_cartons_sold_count || 0
                    }
                    unit={t("DashboardAnalytics.cartons")}
                  />
                </div>
                <div className="border-2 w-full p-2 rounded bg-white">
                  <div className="px-3 p-2 font-bold text-13">
                    {t("DashboardAnalytics.totalSARSales")}
                  </div>
                  <VerticalProgressBar
                    firstAmount={
                      dashobardData?.visit_metrics?.preseller_sale_value || 0
                    }
                    secondAmount={
                      dashobardData?.visit_metrics?.salesman_sale_value || 0
                    }
                    unit={t("DashboardAnalytics.SAR")}
                  />
                </div>
                <div className="border border-gray-300 w-full rounded p-4 bg-white min-h-[250px] flex-1">
                  <h2 className="text-13 font-bold">
                    {t("DashboardAnalytics.codOrders")}
                  </h2>
                  <div className="flex justify-between items-center">
                    <div className="pl-0 p-4">
                      <p className="text-13 font-medium">
                        {t("DashboardAnalytics.totalOrders")}
                      </p>
                      <p className="font-bold text-[31px]">
                        {formatNumberWithoutFraction(
                          dashobardData?.visit_metrics
                            ?.total_cod_orders_count || 0
                        )}
                      </p>
                    </div>
                    <div className="border-2 w-[2px] h-12"></div>
                    <div className="border-gray-300 p-2 text-13">
                      <p>{t("DashboardAnalytics.cartonQuantity")}</p>
                      <p className="font-bold text-[31px]">
                        {formatNumberWithoutFraction(
                          dashobardData?.visit_metrics?.cod_cartons_qty || 0
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="border-t border-gray-300 rounded p-2 pl-0">
                    <p className=" text-13 font-bold">
                      {t("DashboardAnalytics.orderValue")}
                    </p>
                    <p className="text-[31px] font-bold text-green-500">
                      {formatNumber(
                        dashobardData?.visit_metrics?.total_cod_order_value ||
                          0
                      ) + " "}
                      {t("DashboardAnalytics.sar")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-4 bg-[#F5F5F5] flex-col md:w-full lg:w-[30%] p-2 rounded">
            <div className="border border-gray-300 rounded p-4 bg-white">
              <h2 className="text-13 font-bold">
                {t("DashboardAnalytics.totalInvoicePOGenerated")}
              </h2>
              <div className="pt-4">
                <HorizontalBar
                  invoiceValue={
                    dashobardData?.visit_metrics?.total_invoices_count || 0
                  }
                  poValue={
                    dashobardData?.visit_metrics?.total_purchase_orders_count ||
                    0
                  }
                  firstName={t("DashboardAnalytics.invoice")}
                  secondName={t("DashboardAnalytics.po")}
                />
              </div>
            </div>
            <div className="border border-gray-300 rounded p-4 bg-white">
              <h2 className="text-13 font-bold ">
                {t("DashboardAnalytics.teleOrder")}
              </h2>
              <div className="flex justify-between items-center mb-2 mt-2">
                <div className="pl-0 p-2">
                  <p className="text-13">{t("DashboardAnalytics.totalPo")}</p>
                  <span className="font-bold">
                    {formatNumberWithoutFraction(
                      dashobardData?.visit_metrics?.total_tele_orders_count || 0
                    )}
                  </span>
                </div>
                <div className="border-2 w-[2px] h-14"></div>
                <div className="border-gray-300 p-2">
                  <p className="text-13">{t("DashboardAnalytics.cartonQty")}</p>
                  <span className="font-bold ">
                    {formatNumberWithoutFraction(
                      dashobardData?.visit_metrics
                        ?.total_tele_order_cartons_sold_count || 0
                    )}
                  </span>
                </div>
              </div>
              <div className="border-gray-300 p-2 border-t-2">
                <p className="text-13">
                  {t("DashboardAnalytics.totalOrderValue")}
                </p>
                <span className="font-bold ">
                  {formatNumber(
                    dashobardData?.visit_metrics?.total_tele_order_value || 0
                  )}
                </span>
              </div>
            </div>
            <div className="bg-white p-2 border-2 flex justify-between rounded items-center px-4 min-h-[120px] flex-wrap">
              <h2 className="text-13 font-bold ">
                {t("DashboardAnalytics.dropSize")}
              </h2>
              <p className="text-purple font-bold text-[39px]">
                {formatNumber(
                  dashobardData?.visit_metrics?.drop_size_count || 0
                )}
              </p>
            </div>
            <div className="bg-white p-4 border-2 flex justify-between items-center min-h-[120px] rounded flex-wrap">
              <h2 className="text-13 font-bold ">
                {t("DashboardAnalytics.Average")}
                <br />
                {t("DashboardAnalytics.averageCartonsPerRoute")}
              </h2>
              {dashboardDataaLoading ? (
                <SkeletonLoader />
              ) : (
                <div className="text-purple font-bold text-[39px]">
                  {dashboardDataa?.average_carton_per_route ?? 0}
                </div>
              )}
            </div>
            <div className="bg-white p-4 border-2 flex justify-between items-center min-h-[120px] rounded flex-wrap">
              <h2 className="text-13 font-bold ">
                {t("DashboardAnalytics.Average")}
                <br />
                {t("DashboardAnalytics.averageInvoicePerCustomer")}
              </h2>
              {dashboardDataaLoading ? (
                <SkeletonLoader />
              ) : (
                <div className="text-purple font-bold text-[39px]">
                  {dashboardDataa?.average_invoice_per_customer ?? 0}
                </div>
              )}
            </div>

            <div className="bg-white p-4 border-2 flex flex-col rounded">
              <h2 className="text-13 font-bold">
                {t("DashboardAnalytics.collectedAmount")}
              </h2>
              <div className="flex flex-row justify-between">
                <p className="font-bold text-3xl text-green-400 pt-2">
                  {formatNumber(
                    dashobardData?.visit_metrics?.total_collected_amount || 0
                  )}{" "}
                  {t("DashboardAnalytics.SAR")}
                </p>
              </div>
              <div className="border-t-2 flex justify-between pt-2">
                {/* todo */}
                <div>
                  <p className="text-16 font-bold">
                    {formatNumber(
                      dashobardData?.visit_metrics
                        ?.total_collected_amount_by_card || 0
                    )}{" "}
                    {t("DashboardAnalytics.SAR")}
                  </p>
                  <p className="text-13 font-semibold">
                    {t("DashboardAnalytics.byCard")}
                  </p>
                </div>
                <div className="border w-[1px]"></div>
                <div>
                  <p className="text-16 font-bold">
                    {formatNumber(
                      dashobardData?.visit_metrics
                        ?.total_collected_amount_by_cash || 0
                    )}{" "}
                    {t("DashboardAnalytics.SAR")}
                  </p>
                  <p className="text-13 font-semibold">
                    {t("DashboardAnalytics.byCash")}
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-gray-300 rounded p-4 bg-white">
              <h2 className="text-13 font-bold">
                {t("DashboardAnalytics.newCustomerCreated")}
              </h2>
              <div className="mt-4">
                <HorizontalThreeBar
                  firstValue={
                    dashobardData?.visit_metrics
                      ?.new_customers_created_approved_count || 0
                  }
                  secondValue={
                    dashobardData?.visit_metrics?.new_customers_created_count ||
                    0
                  }
                  ThirdValue={
                    dashobardData?.visit_metrics
                      ?.new_customers_created_rejected_count || 0
                  }
                  firstName={t("DashboardAnalytics.approved")}
                  secondName={t("DashboardAnalytics.underApproval")}
                  thirdName={t("DashboardAnalytics.rejected")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Channel;
